import { isUnbridaledDasUrl } from '@unbridaled/search-sdk/product-media'

export type CertificateAction = { kind: 'window'; url: string } | { kind: 'modal'; src: string }

/**
 * Decides how a certificate link is shown. Mirrors search-sdk's own rule (and console-ui's
 * registered handler): DAS-hosted certificates (the Retail Certificate, a `das/` S3 URL) render
 * in the viewer app's /cert page inside an in-page modal; external lab links (IGI, GIA, ...)
 * open in a new tab. Without a viewer URL there is nothing to embed, so fall back to a new tab.
 */
export const getCertificateAction = (uri: string, viewerUrl?: string): CertificateAction => {
  if (!viewerUrl || !isUnbridaledDasUrl(uri)) return { kind: 'window', url: uri }
  return { kind: 'modal', src: `${viewerUrl}/cert?cert_url=${encodeURIComponent(uri)}` }
}
